import React from 'react';
import { Route } from 'react-router-dom';
import Loadable from 'react-loadable';

import Loading from 'lib/components/Loading'; // eslint-disable-line

const AlbumsContainer = Loadable({
  loader: () => import('../containers/AlbumsContainer'),
  loading: Loading,
});
const PhotosContainer = Loadable({
  loader: () => import('../containers/PhotosContainer'),
  loading: Loading,
});

export default (
  <div>
    <Route exact path="/admin/albums" component={AlbumsContainer} />
    <Route
      path="/admin/albums/:album_id/album_photos"
      component={PhotosContainer}
    />
  </div>
);
